import Chat from "./Chat/Chat";
import "./style.scss";


const AssistantSideBar = () => {
    return (
     <div className="assistant-sidebar">
        <Chat/>
     </div>
    )
}

export default AssistantSideBar;